module.exports = __webpack_public_path__ + "img/logo3.4331ea1d.png";